module.exports = __webpack_public_path__ + "static/media/29FUNOV12.35ea0bab.jpg";